import React from "react";
import { HeaderBarProps } from "web/react/components/app-header/header-bar/header-bar";
import NotificationsLink from "./notifications-link";
// eslint-disable-next-line css-modules/no-unused-class
import SavedSearchLink from "./saved-search-link";
import WishListLink from "./wish-list-link";

export type AccountLink = {
    url: string;
};

type AccountLinks = Pick<
    HeaderBarProps,
    | "mySearchesUrl"
    | "hasItemsInWishlist"
    | "savedItemUrl"
    | "notificationsUrl"
    | "notificationsCount"
>;

function AccountLinks({
    mySearchesUrl,
    savedItemUrl,
    hasItemsInWishlist,
    notificationsUrl,
    notificationsCount,
}: AccountLinks): JSX.Element {
    return (
        <>
            <SavedSearchLink url={mySearchesUrl as string} />
            <WishListLink url={savedItemUrl as string} hasItemsInWishlist={hasItemsInWishlist} />
            <NotificationsLink
                url={notificationsUrl as string}
                notificationsCount={notificationsCount}
            />
        </>
    );
}

export default AccountLinks;
